__turbopack_context__.v({
  "box": "split-pill-module__i4sdSq__box",
  "caret": "split-pill-module__i4sdSq__caret",
  "more": "split-pill-module__i4sdSq__more",
  "pill": "split-pill-module__i4sdSq__pill",
  "word": "split-pill-module__i4sdSq__word",
});
